var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"text-bg-ctn",staticClass:"text-bg-ctn"},[_c('div',{attrs:{"data-depth":"0.2"}},[_c('div',{ref:"text-bg",staticClass:"text-bg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }